export const AUTH_CONSTANTS = {
    VC: 'vc',
    VCD: 'vcd',
    VIO: 'vio',
    OrgAdmin: 'Organization Administrator',
    SysAdmin: 'System Administrator'
};



// WEBPACK FOOTER //
// ./src/app/auth/auth-constants.ts